export default {
  authUrl: null,
  adminApiUrl: null,
  lotteryApiUrl: null,
  telegramAdminApiUrl: null
};
